var React = require('react');

function TrencherInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M28.8 5.5001L15.5 0.200098C14.8 -0.0999023 14.1 -0.0999023 13.4 0.200098L0.500003 5.4001C-0.099997 5.7001 -0.099997 6.6001 0.500003 6.8001L5.8 8.9001V14.0001L6.2 14.4001C6.3 14.5001 9.1 17.2001 14.5 17.2001C19.9 17.2001 22.7 14.5001 22.8 14.4001L23.2 14.0001V8.9001L25.7 7.9001V13.5001C25.7 14.2001 26.2 14.7001 26.9 14.7001H27.1C27.7 14.7001 28.2 14.2001 28.2 13.6001V6.9001L29 6.6001C29.2 6.4001 29.2 5.7001 28.8 5.5001ZM20.6 12.9001C19.8 13.5001 17.8 14.7001 14.4 14.7001C11 14.7001 9 13.5001 8.2 12.9001V9.9001L13.5 12.0001C14.1 12.2001 14.7 12.2001 15.3 12.0001L20.6 9.9001V12.9001ZM14.4 9.7001L5.4 6.1001L14.4 2.5001L23.4 6.1001L14.4 9.7001Z","fill":"white"}));
}

TrencherInline.defaultProps = {"width":"30","height":"18","viewBox":"0 0 30 18","fill":"none"};

module.exports = TrencherInline;

TrencherInline.default = TrencherInline;
